// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/assets/styles/admin.scss
// module id = 3
// module chunks = 0